import React, { useState } from 'react';
import axios from "axios";
import { useRequestInterceptor, useResponseInterceptor } from "../../services/interceptors";

const AUTH_TOKEN_HEADER = 'authToken';
const RequestContext = React.createContext();
export const axiosInstance = axios.create();

export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_HEADER, token);
};

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_HEADER);
};

export const RequestProvider = ({ children }) => {
  const [loggedUser, setLoggedUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [alertContent, setAlertContent] = useState({});

  useRequestInterceptor(axiosInstance, setLoading);
  useResponseInterceptor(axiosInstance, setLoading, setAlertContent);

  return (
    <RequestContext.Provider value={{
      loading,
      setLoading,
      loggedUser,
      setLoggedUser,
      alertContent,
      setAlertContent
    }}>
      {children}
    </RequestContext.Provider>
  );
};

export default RequestContext;